import WalkinBooking from "./components/WalkinBooking/WalkinBooking.svelte";

declare global {
    interface Window {
        jQuery: any;
        bat_location_vars: any;
    }
}


new WalkinBooking({
    target: document.getElementById("walkin-booking") as HTMLElement,
    props: {},
});
